var _style, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSidebarToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000140000830326188122060000013239372036337685676_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:#231F20;}\n\t.line-color: {fill: #fff;};\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line-color",
    d: "M23,15H6v-1h17V15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "line-color",
    d: "M23,20H6v-1h17V20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "line-color",
    d: "M23,10H6V9h17V10z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 29,
    height: 29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarToggle);
export default __webpack_public_path__ + "static/media/icon-sidebar-toggle.ed9195e7ce4ca4d88caa6e6f77b651ad.svg";
export { ForwardRef as ReactComponent };